import { useContext } from "react"

import { IsoLocale } from "@izettle/constants"
import { useFormatter } from "@izettle/react"

import { LingoTextFunction, TranslatorContext } from "../providers/translations"
import type { Translator } from "../translator"

export type Localization = ReturnType<typeof useFormatter> & {
  translator: Translator
  isoLocale: IsoLocale
  text: LingoTextFunction
}

// Using this value as a memo that works cross components
let useLocalizationReturn: Localization | null = null
export const useLocalization = (): Localization => {
  const { translator, text } = useContext(TranslatorContext)
  const formatters = useFormatter()

  // (Probably unnecessary) production optimization
  // Re-use same formatters, translator, text functions between components
  // In development environments (not production) we always create new ones in case we switch locales
  if (
    process.env.JEST_WORKER_ID == null &&
    process.env.APP_ENV === "production" &&
    useLocalizationReturn
  ) {
    return useLocalizationReturn
  }

  useLocalizationReturn = {
    ...formatters,
    translator,
    isoLocale: translator.locale,
    text,
  }

  return useLocalizationReturn
}
